/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartItemPromoCode_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItemTitle_user$ref: FragmentReference;
export type CartItemTitle_user = {|
  +$fragmentRefs: CartItemPromoCode_user$ref,
  +$refType: CartItemTitle_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartItemTitle_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartItemPromoCode_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f669384126c53b0d3b4889ea84ea98aa';
module.exports = node;
